
class Coin{
    constructor(name, symbol, address){
        this.name = name;
        this.symbol = symbol;
        this.address = address;
        this.price = 1;
    }
    static emtpy(){
        return new Coin("", "", "");
    }
}


const n = ["binancecoin","bitcoin","litecoin","tron","ethereum","binancecoin"];
const s = ["BNB(bep20)","BTC","LTC","TRX","ETH", "BNB"];
const a = [
"0x5F8b6418ef5F71E227F11487F358f99f5C721C85",
"bc1qmxeh5dpzzzp0men5ump98tef5w0pjspqw583vl",
"ltc1qlxgvlqy9gk68esdmvzd0m658nh5y5cmzzc2xjx",
"TU1hRgAQge5MBfsiVYJVS5MrvQsnBnYq9H",
"0x5F8b6418ef5F71E227F11487F358f99f5C721C85",
"0x5F8b6418ef5F71E227F11487F358f99f5C721C85"
];

function retrive(prices){
    let coins = [];
    for(let i = 0; i < n.length; i++){
        const c = new Coin(n[i], s[i], a[i]);
        c.price = prices[n[i]].usd
        if(s[i] == "BNB(bep20)"){
            c.name = "binancecoin(bep20)";
        }
        coins.push(c);
    }
    var usdt = new Coin("tether(bep20)", "USDT(bep20)", "0x5F8b6418ef5F71E227F11487F358f99f5C721C85");
    usdt.price = 1;
    coins.push(usdt);
    var usdt2 = new Coin("tether(trc20)", "USDT(trc20)", "TU1hRgAQge5MBfsiVYJVS5MrvQsnBnYq9H");
    usdt2.price = 1;
    coins.push(usdt2);
    var usdt3 = new Coin("tether(erc20)", "USDT(erc20)", "0x5F8b6418ef5F71E227F11487F358f99f5C721C85");
    usdt3.price = 1;
    coins.push(usdt3);
    coins.sort((a, b) => (a.symbol < b.symbol) ? 1 : -1);
    return coins;
}

async function getCoins(){
    const res = await fetch("https://api.coingecko.com/api/v3/simple/price?ids=binancecoin,bitcoin,litecoin,tron,ethereum&vs_currencies=usd");
    const prices = await res.json();
    return retrive(prices);
}

export {Coin, getCoins};
